import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gw-flag",
  "use": "gw-flag-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"gw-flag\"><path fill=\"none\" d=\"M0 0h24v24H0Z\" /><path d=\"m14.4 6-.24-1.2c-.09-.46-.5-.8-.98-.8H6c-.55 0-1 .45-1 1v15c0 .55.45 1 1 1s1-.45 1-1v-6h5.6l.24 1.2c.09.47.5.8.98.8H19c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1h-4.6Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol